const zmAudio = {};




zmAudio.play = function (type){
    // if(type == 'error'){
    //     document.getElementById("errorWav").play();
    // }else{
    //     document.getElementById("okWav").play();
    // }
    switch (type){
        case 'error':document.getElementById("errorWav").play();break;
        case 'HK-M.WAV':document.getElementById("HK-MWav").play();break;
        case 'HK-P.WAV':document.getElementById("HK-PWav").play();break;
        case 'MYE01-M.WAV':document.getElementById("MYE01-MWav").play();break;
        case 'MYE01-P.WAV':document.getElementById("MYE01-PWav").play();break;
        case 'MYE02-M.WAV':document.getElementById("MYE02-MWav").play();break;
        case 'MYE02-P.WAV':document.getElementById("MYE02-PWav").play();break;
        case 'MYE03.WAV':document.getElementById("MYE03Wav").play();break;
        case 'MYE03-M.WAV':document.getElementById("MYE03-MWav").play();break;
        case 'MYE-M.WAV':document.getElementById("MYE-MWav").play();break;
        case 'MYE-P.WAV':document.getElementById("MYE-PWav").play();break;
        case 'MYW-M.WAV':document.getElementById("MYW-MWav").play();break;
        case 'MYW-P.WAV':document.getElementById("MYW-PWav").play();break;
        case 'SG-M.WAV':document.getElementById("SG-MWav").play();break;
        case 'SG-P.WAV':document.getElementById("SG-PWav").play();break;
        case 'TH-M.WAV':document.getElementById("TH-MWav").play();break;
        case 'TH-P.WAV':document.getElementById("TH-PWav").play();break;
        case 'TW-M.WAV':document.getElementById("TW-MWav").play();break;
        case 'TW-P.WAV':document.getElementById("TW-PWav").play();break;
        case 'sava':document.getElementById("savaWav").play();break;
        default: document.getElementById("okWav").play();
    }


};

zmAudio.init = function () {
    let wav1 = document.getElementById("errorWav");
    let protocolStr = document.location.protocol == 'https:' ? 'https' : 'http';
    if(!wav1){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/ScanWavError.wav';
        audio.id = 'errorWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wavok = document.getElementById("okWav");
    if(!wavok){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/ScanWavOK.wav';
        audio.id = 'okWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav2 = document.getElementById("HK-MWav");
    if(!wav2){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/HK-M.wav';
        audio.id = 'HK-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav3 = document.getElementById("HK-PWav");
    if(!wav3){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/HK-P.wav';
        audio.id = 'HK-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav4 = document.getElementById("MYE01-MWav");
    if(!wav4){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/MYE01-M.wav';
        audio.id = 'MYE01-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav5 = document.getElementById("MYE01-PWav");
    if(!wav5){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/MYE01-P.wav';
        audio.id = 'MYE01-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav6 = document.getElementById("MYE02-MWav");
    if(!wav6){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/MYE02-M.wav';
        audio.id = 'MYE02-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav7 = document.getElementById("MYE02-PWav");
    if(!wav7){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/MYE02-P.wav';
        audio.id = 'MYE02-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav8 = document.getElementById("MYE03-MWav");
    if(!wav8){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/MYE03-M.wav';
        audio.id = 'MYE03-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav9 = document.getElementById("MYE03-PWav");
    if(!wav9){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/MYE03-P.wav';
        audio.id = 'MYE03-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav10 = document.getElementById("MYE-MWav");
    if(!wav10){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/MYE-M.wav';
        audio.id = 'MYE-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav11 = document.getElementById("MYE-PWav");
    if(!wav11){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/MYE-P.wav';
        audio.id = 'MYE-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav12 = document.getElementById("MYW-MWav");
    if(!wav12){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/MYW-M.wav';
        audio.id = 'MYW-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav13 = document.getElementById("MYW-PWav");
    if(!wav13){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/MYW-P.wav';
        audio.id = 'MYW-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav14 = document.getElementById("SG-MWav");
    if(!wav14){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/SG-M.wav';
        audio.id = 'SG-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav15 = document.getElementById("SG-PWav");
    if(!wav15){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/SG-P.wav';
        audio.id = 'SG-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav16 = document.getElementById("TH-MWav");
    if(!wav16){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/TH-M.wav';
        audio.id = 'TH-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav17 = document.getElementById("TH-PWav");
    if(!wav17){
        var audio = new Audio();
        audio.src = protocolStr + '://'+window.location.host+'/static/wav/TH-P.wav';
        audio.id = 'TH-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav18 = document.getElementById("TW-MWav");
    if(!wav18){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/TW-M.wav';
        audio.id = 'TW-MWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav19 = document.getElementById("TW-PWav");
    if(!wav19){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/TW-P.wav';
        audio.id = 'TW-PWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }
    let wav20 = document.getElementById("savaWav");
    if(!wav20){
        var audio = new Audio();
        audio.src =protocolStr + '://'+window.location.host+'/static/wav/sava.wav';
        audio.id = 'savaWav';
        audio.preload = 'auto';
        document.body.appendChild(audio)
    }



}




export default zmAudio;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmAudioService.js